import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { colors } from '../../colors'
// import { Nav }

import{ search_icon } from '../../assets'

const SearchInput = ({resource}) => {

  const [filteredData, setFilteredData] = useState([])
  const [searchQuery, setSearchQuery] = useState('')
  const [loading, setLoading] = useState()
  const [error, setError ] = useState()
  const [errorMessage, setErrorMessage] = useState()


  const handleFilter = (e) =>{
     setSearchQuery(e.target.value.toLowerCase())
    // const newFilter = resource.filter((value) => {
    //   return value.resourceTitle.toLowerCase().includes(searchQuery.toLowerCase()) 
    // });

    // if(searchQuery === ''){
    //   setFilteredData([]);
    // }else{
    //   setFilteredData(newFilter);
    // }
  }

  


    useEffect(() => {
        let mounted = true;
        const getResourceByCategory = async () => {
          try {
            const response = await fetch(
                
                ("https://nigeriana-api-staging.herokuapp.com/api/v1/library/public/resources/search?searchQuery=" +  searchQuery),
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
            const data = await response.json();
            // setResources(data?.data?.results[0]?._source);
            setFilteredData(data?.data?.results)
            setLoading(false);
          } catch (error) {
            setError(true);
            setErrorMessage(error?.message);
            setLoading(false);
          }
        };
        if (mounted && searchQuery !== '') {
            getResourceByCategory();
            
        }
        return () => {
          mounted = false;
        }; 
      }, [searchQuery]);


  const onSubmit = (e) => {
    e.preventDefault()

    // navigate('/advanced-search')
  }

  return (
    
      <Container>
          <img src={search_icon} alt="search icon" />

          <form onSubmit={onSubmit} >
            <input 
            type="text" 
            placeholder='Type in a search keyword'
            value={searchQuery}
            onChange={handleFilter} 
            />
            <Button>Search</Button>

          </form>

      {filteredData.length !== 0 &&(
      
                <SearchResult>
                {
                    filteredData?.slice(0, 10)?.map((search) =>{
                      return(
                        <div key={search?._source?.resourceId}>  
                          <NavLink to={`/resource/${search?._source?.resourceNlnCode} `}>
                            {search?._source.resourceTitle}
                          </NavLink>
                        </div>
                      )
                    } )
                  }
                </SearchResult>
      
      )}          
          
      </Container>
    
  )
}

const Container = styled.div`
    display: flex;
    flex-direction: row;
    width: 50%;
    height: 50px;
    /* justify-content: space-between; */
    align-items: center;
    background-color: ${colors.white};
    padding: 12px;
    border-radius: 4px;
    position: relative;
    margin-top: 10px;

    @media screen and (max-width: 600px){

      width: 90%;
      margin-top: 20px;
      padding: 12px;
    }

   
    & > form{

      

      & input{
        border: none;
        outline: none;
        padding: 10px;
        width: 100%;
        flex: 1;
        background-color: #fff;

        & :focus {
          background-color: #fff;
        }

        
    }


    }

    
 
`

const Button = styled.button`
    padding: 12px 27px;
        /* text-align: center; */
        width: fit-content;
        background-color: ${colors.secondary};
        border-radius: 0px 4px 4px 0px;
        border: none;
        position: absolute;
        right: 0%;
        bottom: 0%;
        align-self: center;
        font-size: 18px;
        height: 100%;
        font-weight: 600;
        color: ${colors.white};
        cursor: pointer;

        @media screen and (max-width: 600px){
          font-size: 14px;
          padding: 14px 6px;
          /* top: ; */
        }
`

const SearchResult = styled.div`
      width: 100%;
      padding: 10px;
      margin-top: 20px;
      overflow: hidden;
      overflow-y: auto;
      background-color: aliceblue;
      border-radius: 5px;
      position: absolute;
      top: 35px;
      left: 0;
      right: 0;

      &::-webkit-scrollbar{
        /* display: none; */
      }

      & > div {
        background-color: #808183;
        padding: 10px;
        border-radius: 5px;

        margin-bottom: 5px;
      } 
`

const NavLink = styled(Link)`
    color: #101828;
    font-size: 1.6rem;
    /* width: max-content; */
    padding-top: 1rem;
    padding-bottom: 1rem;
    width: inherit;

    
`
  


export {SearchInput}